import { Button } from '@kerfjs/ui/button';
import { List } from '@kerfjs/ui/list';
import { DialogSurface } from '@kerfjs/ui/surface-scaffold';
import { ValueTable, ValueTableRow } from '@kerfjs/ui/value-table';
import type { SafeHtml } from 'kerfjs';

import type { IntakeDoc } from '../../../data/state.js';

export const ATTACHMENT_ERRORS_DIALOG_ACTIONS = {
  close: 'attachment-errors-close',
  retryQuotation: 'attachment-error-retry-quotation',
} as const;

/** Lists the attachments whose processing failed and why; closed from its footer action. */
export function AttachmentErrorsDialog({
  failed,
  canRetry = false,
  lightDismiss = false,
}: {
  failed: readonly IntakeDoc[];
  canRetry?: boolean;
  lightDismiss?: boolean;
}): SafeHtml {
  return (
    <DialogSurface
      label="Attachment Processing Errors"
      className="attachment-errors-dialog"
      lightDismiss={lightDismiss}
      rootAttributes={{ 'data-auto-open-dialog': '' }}
      footer={
        <Button
          tone="neutral"
          emphasis="primary"
          size="default"
          action={ATTACHMENT_ERRORS_DIALOG_ACTIONS.close}
          rootAttributes={{ 'data-dialog-close': '' }}
        >
          Close
        </Button>
      }
    >
      <ValueTable label="Files That Could Not Be Processed" stackBelow="compact">
        {failed.map((doc) => (
          <ValueTableRow
            label={doc.filename}
            value={
              <List gap="xs">
                <span>{doc.extractionResult?.extractionError ?? 'The file could not be processed.'}</span>
                {canRetry && (doc.kind === 'quotation' || doc.kind === 'comparison-sheet') ? (
                  <Button
                    tone="neutral"
                    emphasis="primary"
                    size="compact"
                    action={ATTACHMENT_ERRORS_DIALOG_ACTIONS.retryQuotation}
                    rootAttributes={{ 'data-document-id': doc.id }}
                  >
                    Retry
                  </Button>
                ) : null}
              </List>
            }
          />
        ))}
      </ValueTable>
    </DialogSurface>
  );
}
